module.exports = __webpack_public_path__ + "static/img/gr.4a4d3e25.svg";